// extracted by mini-css-extract-plugin
export default {"uploadFiles":"ZFQion8SfqlrX78Tlc7p"};